export const applicationsPath = {
  applications: "applications",
  applicationTeamChat: 'teamChat',
  documents: 'documents',
  sections: 'docSections',
  comments: 'docsSectionComments',
}
